module.exports = __webpack_public_path__ + "img/Loader.35e8e123.svg";